'use client'

import PageWrapper from 'Components/Blocks/PageWrapper'
import { Column } from 'Components/UI'

import {
  LANDING_INLINE_PADDINGS,
  LANDING_MAX_CONTENT_WIDTH_PX,
} from 'Constants/Landing'

import Hero from './hero'

function NotFoundPage() {
  return (
    <PageWrapper secondary>
      <Column
        alignCenter
        as="main"
        fullHeight
        fullWidth
        justifyCenter
        maxWidth={LANDING_MAX_CONTENT_WIDTH_PX}
        px={LANDING_INLINE_PADDINGS}
      >
        <Hero />
      </Column>
    </PageWrapper>
  )
}

export default NotFoundPage
